module.exports = __webpack_public_path__ + "static/image-01cefa13943d67a516ceac11c93d0295.png";